import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { cn, getStatusLabel } from '../../../lib/utils';
import { Layers } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
export const GrupoDialog = ({ cn, editingGrupoId, getGrupoDe, grupoForm, grupos, handleSaveGrupo, isGrupoDialogOpen, savingGrupo, setEditingGrupoId, setGrupoForm, setIsGrupoDialogOpen, sortUnidades, unidades }) => {
  return (
      <Dialog open={isGrupoDialogOpen} onOpenChange={(open) => {
        setIsGrupoDialogOpen(open);
        if (!open) setEditingGrupoId(null);
      }}>
        <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Layers className="w-5 h-5 text-indigo-600" />
              {editingGrupoId ? 'Editar Grupo' : 'Agrupar Unidades'}
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSaveGrupo} className="space-y-4">
            <div className="space-y-2">
              <Label>Nombre del grupo *</Label>
              <Input
                value={grupoForm.nombre}
                onChange={(e) => setGrupoForm({...grupoForm, nombre: e.target.value})}
                placeholder="Ej: Unidad Económica Piso 1"
                required
                data-testid="grupo-nombre"
              />
            </div>
            <div className="space-y-2">
              <Label>Seleccionar unidades (mínimo 2)</Label>
              <p className="text-xs text-slate-400">Las unidades ya agrupadas en otros grupos no se pueden seleccionar.</p>
              <div className="border rounded-lg max-h-60 overflow-y-auto divide-y">
                {sortUnidades(unidades)
                  .map(u => {
                    // Una unidad está bloqueada si pertenece a OTRO grupo (no al que estamos editando)
                    const grupoDeUnidad = getGrupoDe(u.unidad_id);
                    const yaEnOtroGrupo = grupoDeUnidad && grupoDeUnidad.grupo_id !== editingGrupoId;
                    const isSelected = grupoForm.unidad_ids.includes(u.unidad_id);
                    return (
                      <label
                        key={u.unidad_id}
                        className={cn(
                          "flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-slate-50",
                          yaEnOtroGrupo && "opacity-40 cursor-not-allowed",
                          isSelected && "bg-indigo-50"
                        )}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          disabled={yaEnOtroGrupo}
                          onChange={(e) => {
                            const ids = e.target.checked
                              ? [...grupoForm.unidad_ids, u.unidad_id]
                              : grupoForm.unidad_ids.filter(id => id !== u.unidad_id);
                            setGrupoForm({...grupoForm, unidad_ids: ids});
                          }}
                          className="rounded border-slate-300"
                          data-testid={`grupo-check-${u.unidad_id}`}
                        />
                        <div className="flex-1">
                          <span className="font-medium text-sm">{u.nombre_unidad}</span>
                          <span className="text-xs text-slate-500 ml-2">{getStatusLabel(u.tipo)}</span>
                        </div>
                        {yaEnOtroGrupo && (
                          <span className="text-xs text-slate-400">En grupo: {grupoDeUnidad?.nombre}</span>
                        )}
                      </label>
                    );
                  })}
              </div>
              <p className="text-xs text-slate-500">
                {grupoForm.unidad_ids.length} seleccionada{grupoForm.unidad_ids.length !== 1 ? 's' : ''}
              </p>
            </div>
            
            {/* Opción de mismo propietario */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={grupoForm.mismo_propietario}
                  onChange={(e) => setGrupoForm({...grupoForm, mismo_propietario: e.target.checked})}
                  className="mt-1 rounded border-blue-300"
                  data-testid="mismo-propietario-check"
                />
                <div>
                  <span className="font-medium text-sm text-blue-900">Mismo propietario para todas las unidades</span>
                  <p className="text-xs text-blue-700 mt-0.5">
                    Si activas esta opción, al cargar el propietario en cualquier unidad del grupo, se aplicará automáticamente a todas las demás (incluyendo fecha de compra y monto de inversión).
                  </p>
                </div>
              </label>
            </div>
            
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => {
                setIsGrupoDialogOpen(false);
                setEditingGrupoId(null);
              }}>Cancelar</Button>
              <Button type="submit" disabled={savingGrupo || grupoForm.unidad_ids.length < 2} data-testid="guardar-grupo-btn">
                {savingGrupo ? (editingGrupoId ? 'Guardando...' : 'Creando...') : (editingGrupoId ? 'Guardar Cambios' : 'Crear Grupo')}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
  );
};
